import { OkThxWordmark } from "@/components/icons/Logo.tsx";
import { HeaderUtilitySlot } from "@/components/layout/HeaderUtilitySlot.tsx";
import { Button } from "@/components/ui/button.tsx";
import { logout } from "@/lib/logout.ts";
import { Check } from "lucide-react";

interface OnboardingHeaderProps {
  currentStep: number;
  totalSteps: number;
  /**
   * Whether to offer a way to sign out. Every screen here sits behind the
   * phone-number guard, so someone who signed in with the wrong account and has
   * no number to give has no other way off it (BIG-9443). A step-up leaves it
   * off: that user is fully onboarded and can already navigate away.
   */
  showLogout: boolean;
}

export const OnboardingHeader = ({
  currentStep,
  totalSteps,
  showLogout,
}: OnboardingHeaderProps) => {
  const progress = ((currentStep + 1) / totalSteps) * 100;
  const completed = currentStep === totalSteps - 1;

  return (
    <div className="sticky top-0 z-50 w-full flex flex-row justify-between items-center px-4 py-6 md:p-8">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-6">
          <a href="/">
            <OkThxWordmark className="h-6 w-auto" />
          </a>
        </div>
      </div>

      <div className="flex items-center gap-2">
        <div className="w-[100px] bg-white rounded-full h-1">
          <div
            className="bg-primary h-1 rounded-full transition-all duration-300 ease-out"
            style={{ width: `${progress}%` }}
          />
        </div>
        {completed && <Check className="w-4 h-4 text-primary" />}
        {/* Onboarding has no site header, and its upper right is already spoken
            for by the progress bar — so the utilities publish into that group
            rather than falling back to a corner the bar is sitting in. */}
        <HeaderUtilitySlot />
        {showLogout && (
          <Button
            variant="ghost"
            size="sm"
            onClick={() => void logout()}
            data-statsig-name="onboarding-logout"
          >
            Log out
          </Button>
        )}
      </div>
    </div>
  );
};
